const block = document.querySelector('section.hero-updated');

if(block) {
    let words = block.querySelectorAll('.anim-vertical span');
    let wordCount = words.length;
    let animLength = wordCount * 3; // 3 seconds per word

    // dynamic keyframes based on word count
    function createKeyframes(wordCount) {
        const singleWordDuration = 100 / wordCount;
        const fadeInDuration = singleWordDuration * 0.15;
        const visibleDuration = singleWordDuration * 0.6;
        const fadeOutDuration = singleWordDuration * 0.15;


        let keyframes = `
            @keyframes animUpDynamic {
                0% { opacity: 0; }
                ${fadeInDuration.toFixed(2)}% { opacity: 1; }
                ${(fadeInDuration + visibleDuration).toFixed(2)}% { opacity: 1; }
                ${(fadeInDuration + visibleDuration + fadeOutDuration).toFixed(2)}% { opacity: 0; }
                ${singleWordDuration.toFixed(2)}% { opacity: 0; }
                100% { opacity: 0; }
            }
        `;

        return keyframes;
    }

    // Inject keyframes
    function injectKeyframes() {
        const styleSheet = document.createElement('style');
        styleSheet.type = 'text/css';
        styleSheet.innerHTML = createKeyframes(wordCount);
        document.head.appendChild(styleSheet);
    }

    // Init
    injectKeyframes();

    words.forEach(function(word, index){
        word.style.animation = `animUpDynamic ${animLength}s linear infinite 0s`;
        word.style.animationDelay = (animLength / wordCount * index) + 's';
    });

    // Video popup
    let popup = block.querySelector('.video-popup');
    if(popup) {
        let watchBtn = block.querySelector('.video-btn');
        let overlay = block.querySelector('.video-overlay');
        let closeBtn = block.querySelector('.close-popup');
        let iframe = block.querySelector('iframe');
        let videoSrc = null;
        if(iframe) {
            videoSrc = iframe.getAttribute('src');
        }

        watchBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if(popup.classList.contains('show-popup')) {
                closePopup();
            }
            else {
                if(iframe.getAttribute('src') == '') {
                    iframe.setAttribute('src', videoSrc);
                }
                popup.classList.add('show-popup');
                overlay.classList.add('show');
                document.querySelector('body').classList.add('no-scroll');
            }
        });

        closeBtn.addEventListener('click', function(e) {
            e.preventDefault();
            closePopup();
        });

        document.addEventListener('click', event => {
            const isClickInside = overlay.contains(event.target) || popup.querySelector('.popup-top').contains(event.target);
            if (isClickInside && popup.classList.contains('show-popup')) {
                closePopup();
            }
        });

        function closePopup() {
            popup.classList.remove('show-popup');
            overlay.classList.remove('show');
            document.querySelector('body').classList.remove('no-scroll');
            popup.querySelector('iframe').setAttribute('src', '');
        }
    }
}